export const withThousandsSeparator = (value: number): string => {
  return Number(value).toLocaleString();
};
